import script from "./chat-results.vue?vue&type=script&setup=true&lang=js"
export * from "./chat-results.vue?vue&type=script&setup=true&lang=js"

import "./chat-results.vue?vue&type=style&index=0&id=2b022a34&lang=scss"

const __exports__ = script;

export default __exports__